import { Container, Row, Col } from 'reactstrap'


export default function FourSection() {

    const items = [
        {
            src: '../images/lp/top1-profile.png',

            altText: 'Seu Jogo em um só lugar',
            caption:
                'Acesse suas estatísticas, desafios e conexões em um só lugar.',
        },
        {
            src: '../images/lp/top2-profile.png',
            altText: 'Sua jornada para o topo',
            caption:
                'Dispute pontos, jogue com tenistas do seu nível e suba no ranking.',
        },
        {
            src: '../images/lp/top3-profile.png',
            altText: 'A cada jogo, uma nova conquista',
            caption:
                'Desafios concluídos rendem novas conquistas para seu perfil.',
        },
        {
            src: '../images/lp/top4-profile.png',

            altText: 'Evolua seu jogo',
            caption: 'Encontre professores perto de você e evolua suas técnicas de jogo.',
        },
    ]
    return (
        <section className="members-section">
            <div
                style={{
                    backgroundColor: '#FFFF',
                    padding: '1rem',
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                <Container className="section-two">
                    <Row>
                        <Col className="text-area">
                            <h3 className="section-title text-primary fw-bold">Conectando quem vive o tênis</h3>
                            <p className="section-subtitle text-primary" style={{ color: '#1D1D1D', fontSize: '16px', fontWeight: '300' }}>
                                Nossa missão é simples: tornar o tênis mais acessível e divertido para todos. Com o Clube do Tennis, você encontra o match perfeito, amplia sua rede de contatos e se diverte em quadra, fortalecendo a comunidade do esporte.
                            </p>
                        </Col>
                    </Row>

                    {/* Lista horizontal com scroll para mobile */}
                    <Row className="mt-4 d-md-none g-0">
                        <Col>
                            <div style={{ position: 'relative', marginLeft: '-1rem', marginRight: '-1rem', paddingLeft: '1rem', paddingRight: '1rem' }}>
                                <div
                                    className="horizontal-scroll"
                                    style={{
                                        display: 'flex',
                                        overflowX: 'auto',
                                        gap: '1rem',
                                        scrollSnapType: 'x mandatory',
                                        WebkitOverflowScrolling: 'touch',
                                        paddingBottom: '0.5rem',
                                    }}
                                >
                                    {items.map((item, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                flex: '0 0 80%',
                                                scrollSnapAlign: 'start',
                                            }}
                                        >
                                            <img
                                                src={item.src}
                                                alt={item.altText}
                                                className="d-block w-100 img-fluid"
                                            />
                                            <div className="carousel-text mt-3">
                                                <h4 className="section-title-grid text-primary fw-bold">{item.altText}</h4>
                                                <p className="section-subtitle-grid text-black">{item.caption}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Grid para Desktop */}
                    <Row className="mt-4 d-none d-md-flex slider-container">
                        {items.map((item, index) => (
                            <Col md="3" key={index} className="slide">
                                <div className="feature-item-card">
                                    <img src={item.src} alt={item.altText} className="img-fluid" />
                                    <div className="feature-text-content"> {/* NOVO WRAPPER PARA O TEXTO */}
                                        <h4 className="section-title-grid text-primary fw-bold">{item.altText}</h4>
                                        <p className="section-subtitle-grid text-black">{item.caption}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>
        </section>
    )
}
